'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _revalidate = require('revalidate');

var _emailValidator = require('email-validator');

var isValidEmail = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (!(0, _emailValidator.validate)(value)) {
      return message;
    }
  };
}, function (field) {
  return field + ' doesn\'t seem to be valid';
});

var isValidUrl = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (value && !/^(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/i.test(value)) {
      return message;
    }
  };
}, function (field) {
  return field + ' doesn\'t seem to be valid';
});

var validate = (0, _revalidate.combineValidators)({
  name: (0, _revalidate.composeValidators)(_revalidate.isRequired)('Name'),
  teamSize: (0, _revalidate.composeValidators)(_revalidate.isRequired)('Team size'),
  releaseDate: (0, _revalidate.composeValidators)(_revalidate.isRequired)('Release date'),
  select: (0, _revalidate.composeValidators)(_revalidate.isRequired)('Select'),

  studio: (0, _revalidate.composeValidators)(_revalidate.isRequired)('Studio'),
  title: (0, _revalidate.composeValidators)(_revalidate.isRequired)('Title'),

  email: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidEmail)('Email'),

  url: (0, _revalidate.composeValidators)(isValidUrl)('Url'),
  comments: function comments() {},
  checkBoxPc: (0, _revalidate.composeValidators)()('Pc'),
  checkBoxSmartPhone: (0, _revalidate.composeValidators)()('SmartPhone'),
  checkBoxPlayStation: (0, _revalidate.composeValidators)()('PlayStation'),
  checkBoxXbox: (0, _revalidate.composeValidators)()('Xbox'),
  checkBoxNitendo: (0, _revalidate.composeValidators)()('Nitendo'),
  checkBoxMac: (0, _revalidate.composeValidators)()('Mac'),
  checkBoxVr: (0, _revalidate.composeValidators)()('Vr'),
  checkBoxOther: (0, _revalidate.composeValidators)()('Pc')

});

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/IndieProgramFormValidation.js
// module id = 1220
// module chunks = 0